import React, { FC } from "react";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import { useGetLocationData } from "~/hooks/locationData";

import Select from "~/shared/ui/Fields/SelectZD";
import SelectDealer from "~/shared/ui/Fields/Select";
import SelectRegion from "~/shared/ui/Fields/Select";
import Button from "~/shared/ui/Fields/Button";

import s from "./SelectDealerForm.less";
import { isArray } from "util";

interface IProps {
  reportSelect: [];
  control?;
  isMultiWatchClick?;
  loading?;
  getReports?;
  menuCustom?;
  errors?;
  selectPlaces?;
  dealersForSelect?;
  selectedService?;
  handleSubmit?;
  reprotFO?;
  fo?;
  cities?;
  isMulti?;
}

const ReportZDForm: FC<IProps> = ({
  reportSelect,
  selectPlaces,
  selectedService,
  isMultiWatchClick,
  errors,
  menuCustom,
  dealersForSelect,
  control,
  loading,
  getReports,
  handleSubmit,
  reprotFO,
  fo,
  cities,
  isMulti,
}) => {
  const { t } = useTranslation();
  const { openModal } = useGetLocationData();

  const arrSelectExcel = [
    "placePosts",
    "warehouses",
    "services",
    "places",
    "tools",
    "toolsInsurance",
    "toolsMetrological",
    "requiredTools",
    "tradePremises",
  ];

  const isArrMulti = isMulti
    ? isMultiWatchClick.length > 0
      ? isMultiWatchClick.find((el) => !el.value)
        ? []
        : reportSelect
      : reportSelect
    : reportSelect;

  return (
    <form onSubmit={handleSubmit(getReports)} className={s.select_dealer_wrap}>
      {!reprotFO && selectedService !== "personal" && (
        <Select
          name={`services`}
          type="zd"
          control={control}
          label={t("zd.select_name")}
          menuCustom={menuCustom}
          desc
          isHeight={true}
          isSearchable={true}
          isMulti={isMulti}
          error={
            isMulti
              ? errors["services"]?.message
              : errors["services"]?.value?.message
          }
          defaultValue={
            !isMulti
              ? {
                  value: null,
                  label: t("zd.nothingSelected"),
                }
              : []
          }
          optionObjects={
            openModal === "ExcelPlace" &&
            selectedService !== "requiredTools" &&
            selectedService !== "tools"
              ? selectPlaces
              : (openModal === "Excel" &&
                  arrSelectExcel.includes(selectedService)) ||
                (openModal === "ExcelPlace" &&
                  selectedService === "requiredTools")
              ? isMulti
                ? [
                    {
                      label: t(`zd.all_${selectedService}`),
                      value: null,
                    },
                    ...isArrMulti,
                  ]
                : [
                    {
                      label: t(`zd.all_${selectedService}`),
                      value: null,
                    },
                    ...reportSelect,
                  ]
              : reportSelect
          }
          vertical
          customClassName={s.dealer_form_select}
        />
      )}

      {reprotFO && (
        <>
          <SelectRegion
            name={`country`}
            control={control}
            label={t("zd.country")}
            optionObjects={[
              {
                value: true,
                label: "Россия",
              },
            ]}
            vertical
            menuCustom={menuCustom}
            customClassName={s.dealer_form_select}
            customClassDesck={s.select_desk}
          />
          <SelectRegion
            name={`FO`}
            control={control}
            label={t("zd.selectedFO")}
            optionObjects={fo}
            error={errors["FO"]?.value?.message}
            vertical
            menuCustom={menuCustom}
            customClassName={s.dealer_form_select}
            customClassDesck={s.select_desk}
          />
          {selectedService === "personal" ? (
            <SelectDealer
              name={"dealerIdFilter"}
              control={control}
              // customClassName={s.item__big}
              label={t("employee.dealerSelect")}
              optionObjects={[
                {
                  value: undefined,
                  label: t("violationsTable.defaultFilterVal"),
                },
                ...dealersForSelect.dealersForSelect,
              ]}
              error={errors["dealerIdFilter"]?.value?.message}
              onScrollBottom={dealersForSelect.introspectionHandler}
              getSearchText={dealersForSelect.searchDealer}
              customClassName={s.dealer_form_select}
              customClassDesck={s.select_desk}
            />
          ) : (
            // <div>select</div>
            <SelectRegion
              name={`cities`}
              control={control}
              label={t("zd.selectedCity")}
              optionObjects={cities}
              error={errors["cities"]?.value?.message}
              vertical
              menuCustom={menuCustom}
              customClassName={s.dealer_form_select}
              customClassDesck={s.select_desk}
            />
          )}
        </>
      )}
      <Button
        txtBtn={t("q.save_excel")}
        customClassName={clsx(s.btn_center, s.correct_margin)}
        // onClick={getReports}
        isForm
        loading={loading}
      />
    </form>
  );
};
export default ReportZDForm;
